import { TargetSolTypeRole, WAKEUP_FORM_DATA } from '../../../../common/common.constants';
import { WakeUp } from '../../../../common/interface/props';
import CreateAccountForm2 from 'components/form/CreateAccount';
import Button from 'components/UI/atoms/Button';

import TitleWrap from '../../molecules/TitleWrap';
import { useSelector } from 'react-redux';
import { RootState } from 'redux_modules';
import Swal from 'sweetalert2';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

interface IProps {
  solType: WakeUp;
}

function CreateAccountForm({ solType }: IProps) {
  const [searchParams] = useSearchParams(); // url param 가져오기
  const [isSt11Valid, setIsSt11Valid] = useState<Boolean>(false); // 11번가 주소록 저장 여부
  const [sendAddressSeq, setSendAddressSeq] = useState<string>('');
  const [returnAddressSeq, setReturnAddressSeq] = useState<string>('');

  const { agreeInfo } = useSelector((state: RootState) => ({
    agreeInfo: state.agreeInfo,
  }));

  async function st11Validation() {
    if (solType === TargetSolTypeRole.ST11) {
      const sendAddressSeq = searchParams.get('sendAddressSeq');
      const returnAddressSeq = searchParams.get('returnAddressSeq');
      const sessionAddressReq = sessionStorage.getItem('addressSeq');
      if (process.env.REACT_APP_DEV === 'true') {
        sessionStorage.setItem('addressSeq', JSON.stringify({ sendAddressSeq: '2', returnAddressSeq: '3' }));
        setIsSt11Valid(true);
      } else if (sessionAddressReq) {
        setIsSt11Valid(true);
      } else if (sendAddressSeq && returnAddressSeq) {
        sessionStorage.setItem('addressSeq', JSON.stringify({ sendAddressSeq: sendAddressSeq, returnAddressSeq: returnAddressSeq }));
        setIsSt11Valid(true);
      } else {
        setIsSt11Valid(false);
      }
    }
    return true;
  }

  useEffect(() => {
    const sendAddSeq = searchParams.get('sendAddressSeq');
    const returnAddSeq = searchParams.get('returnAddressSeq');

    if (sendAddSeq && returnAddSeq) {
      setSendAddressSeq(sendAddSeq);
      setReturnAddressSeq(returnAddSeq);
      sessionStorage.setItem('addressSeq', JSON.stringify({ sendAddressSeq: sendAddSeq, returnAddressSeq: returnAddSeq }));
    }

    st11Validation();
  }, []);

  return (
    <>
      <TitleWrap
        title="회원 가입 정보 입력"
        subject={`플레이오토 간편 회원 가입을 통해 ${WAKEUP_FORM_DATA[solType].name.type1}에 상품을 빠르게 판매하실 수 있습니다.`}
        step={1}
        depth={solType === TargetSolTypeRole.ST11 ? 2 : 3}
        subButton={
          solType === TargetSolTypeRole.ST11 ? (
            <Button
              color="wakeup"
              variant="contained"
              size="small"
              height={45}
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (agreeInfo.status !== 'SUCCESS') {
                  await Swal.fire({
                    title: '실패',
                    html: `이용약관에 동의해주시기 바랍니다.`,
                    icon: 'error',
                    confirmButtonText: '확인',
                  });
                  return;
                }

                if (!isSt11Valid) {
                  await Swal.fire({
                    title: '실패',
                    html: '11번가 SellerOffice 통해 접속한 사용자만 사용이 가능합니다.SellerOffice 출고지, 반품/교환지 정보를 입력한 후, 접속해주시기 바랍니다.',
                    icon: 'error',
                    showCancelButton: true,
                    cancelButtonText: '취소',
                    confirmButtonText: '11번가 접속',

                    preConfirm: () => {
                      window.open('https://soffice.11st.co.kr/pages/external-registration/apply');
                    },
                  });

                  return;
                }
                // 서버가 state 생성 + URL 빌드 + redirect 수행
                window.location.assign(
                  `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/job/st11/authorization-code?sendAddressSeq=${sendAddressSeq}&returnAddressSeq=${returnAddressSeq}`,
                );
              }}
            >
              11번가 계정으로 간편 회원가입
            </Button>
          ) : (
            <></>
          )
        }
      />

      <CreateAccountForm2 solType={solType} />
    </>
  );
}

export default CreateAccountForm;
